import { ENDPOINTS } from '@/settings/endpoints';
import axios, { CancelTokenSource, AxiosError, AxiosProgressEvent } from 'axios';

const MAX_ALLOWED_FILESIZE = 10 * 1024 ** 2;
interface UploadImageResponse {
  success: boolean;
  url: string;
  cancelled: boolean;
}

async function fileUpload(
  fileBase64: string | ArrayBuffer,
  userId: number,
  uploadProgress?: (params: { percent: number }) => void,
  uploadTokenControl?: (cancelToken: CancelTokenSource) => void,
): Promise<UploadImageResponse> {
  let apiResponse: any;

  const cancelToken = axios.CancelToken.source();
  if (uploadTokenControl) {
    uploadTokenControl(cancelToken);
  }

  try {
    apiResponse = await axios.request({
      method: 'post',
      url: ENDPOINTS.fileUpload,
      data: JSON.stringify({
        image: fileBase64,
        operationType: 'EXAM_USER_UPLOAD',
        userId,
      }),
      cancelToken: cancelToken.token,
      onUploadProgress: (progress: AxiosProgressEvent) => {
        if (uploadProgress) {
          const percent = (progress.loaded * 100) / progress.total!;
          uploadProgress({ percent: Math.round(percent) });
        }
      },
    });
  } catch (error) {
    const cancelled = (error as AxiosError).constructor.name === 'Cancel';
    return { success: false, url: '', cancelled };
  }

  if (apiResponse.status === 200 && apiResponse.data.location) {
    return { success: true, url: apiResponse.data.location, cancelled: false };
  }
  return { success: false, url: '', cancelled: false };
}

export { fileUpload, MAX_ALLOWED_FILESIZE };
